
    import { computed, defineComponent, ref } from 'vue';
    import { useRoute } from 'vue-router';

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

        /**
         * Top elements
         */
        const toggleActive = ref<string>('symptoms');
        const toggleItems: string[] = ['symptoms', 'signs'];

        function updateToggleActive (item: string) {
            toggleActive.value = item;
        }


		return { 
            endpointId,
            toggleActive,
            toggleItems,
            updateToggleActive
        }
	}

    export default defineComponent({
        setup() {
            return { ...bespokeComposition() }
        },
    })
